// import moment from 'moment'
import * as partnerPlanAdminOverviewFormSchema from 'schemas/forms/PartnerPlanAdminOverviewForm'
import Heading from 'components/Heading'
import Modal from 'components/Modal'
import { validateAll } from 'utils/validators'
import React, { PropTypes, Component } from 'react'
import SubmitButton from 'components/SubmitButton'
import TextInput from 'components/Form/components/TextInput'
import Alert from 'components/Alert'
import styles from './PartnerPlanAdminOverviewDisplayForm.scss'

import {
  formUpdate,
  formInit,
  formSubmit,
  formReset,
} from 'actions/forms'

class PartnerPlanAdminOverviewDisplayForm extends Component {
  static propTypes = {
    completeText: PropTypes.string,
    confirmation: PropTypes.bool,
    ctaText: PropTypes.string,
    data: PropTypes.object,
    description: PropTypes.string,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    handleFormSubmit: PropTypes.func,
    handleSubmit: PropTypes.func,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    partnerPlanAdmin: PropTypes.object,
    partnerPlanOverviewForm: PropTypes.object,
    show: PropTypes.bool,
    submittingText: PropTypes.string,
    title: PropTypes.string,
  }

  static defaultProps = {
    data: {},
    ctaText: 'Submit',
    completeText: 'Submitted',
    submittingText: 'Submitting',
    show: false,
    confirmation: false,
    partnerPlanAdmin: null,
    partnerPlanOverviewForm: null,
    handleFormSubmit: null,
    handleSubmit: null,
    id: '',
    title: '',
    description: '',
  }

  componentWillMount() {
    const { formFields } = partnerPlanAdminOverviewFormSchema

    const formData = {
      formFields,
      data: this.props.data || null,
    }

    this.props.dispatch(formInit(this.props.id, formData))
  }

  componentWillReceiveProps(nextProps) {
    const { partnerPlanAdmin } = this.props
    const modalCreated = this.props.modals.partnerPlanOverviewForm
    const modalChanged = modalCreated && nextProps.modals.partnerPlanOverviewForm.show !== this.props.modals.partnerPlanOverviewForm.show
    const modalNotVisible = modalCreated && !nextProps.modals.partnerPlanOverviewForm.show
    const modalVisible = modalCreated && nextProps.modals.partnerPlanOverviewForm.show
    // const dataChanged = nextProps.data !== this.props.data

    if (modalChanged && modalNotVisible) {
      this.props.dispatch(formReset(this.props.id))
    }

    if (modalChanged && modalVisible) {
      // preload data from BED if needed
      this._handleChange('year', partnerPlanAdmin.selectedPlanOverviewPage.year.toString())
      this._handleChange('formurl', partnerPlanAdmin.selectedPlanOverviewPage.formurl)
      this._handleChange('guidanceurl', partnerPlanAdmin.selectedPlanOverviewPage.guidanceurl)
      this._handleChange('ID', partnerPlanAdmin.selectedPlanOverviewPage.ID.toString())
      this._handleChange('planstage', partnerPlanAdmin.selectedPlanOverviewPage.planstage)
      this._handleChange('status', partnerPlanAdmin.selectedPlanOverviewPage.status)
    }
  }

  _schema = () => {
    const obj = {}
    partnerPlanAdminOverviewFormSchema.formFields.forEach((field) => {
      obj[field.name] = field
    })
    return obj
  }

  _hide = () => {
    // this.props.dispatch(displayForm(false))
    this.props.hide(this.props.id)
    this.props.dispatch(formReset(this.props.id))
  }

  _handleSubmit = (e) => {
    e.preventDefault()
    const values = this.props.forms[this.props.id]
    const data = {}
    Object.keys(values).forEach((key) => {
      if (key.indexOf('_') < 0) {
        data[key] = values[key].value
      }
    })

    // Validate all the forms fields and return any errors
    const errors = validateAll(partnerPlanAdminOverviewFormSchema.requiredFields, this.props.forms[this.props.id])

    // Check if form has errors
    if (errors.length > 0) {
      // If form has errors handle them
      errors.forEach((errObj) => {
        this._handleError(errObj, errObj.name)
      })
    } else {
      // If form has no errors, pass the serialized form field for submit and set the form to submit.
      // append or map existing data
      this.props.dispatch(formSubmit(this.props.id))
      this.props.handleSubmit(data)
    }
  }

  // Takes an error object for a field and updates the state accordingly
  _handleError(errorObj, stateKey) {
    // Set new state value for field and update state
    const stateValue = {
      data: {
        focus: false,
        error: (errorObj.valid) ? '' : errorObj.error,
        valid: errorObj.valid,
      },
      field: stateKey,
    }
    this._handleState(stateValue)
  }

  _handleState = (stateValue) => {
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleValidation = (name) => {
    const stateValue = {
      field: name,
      data: {
        focus: false,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleFocus = (name) => {
    // Create state value obj
    const stateValue = {
      field: name,
      data: {
        focus: true,
      },
    }

    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  _handleAutoComplete = (name, value) => {
    this._handleChange(name, value)
  }

  // Handle Changes on form elements
  _handleChange = (name, value) => {
    /*
      Create state value obj
      Reset error handling (Stops error check on focus changes)
    */
    const stateValue = {
      field: name,
      data: {
        value,
        error: '',
        valid: true,
      },
    }

    // Pass state value and handle state
    this.props.dispatch(formUpdate(this.props.id, stateValue))
  }

  canSubmit = () => {
    const form = this.props.forms[this.props.id]
    return form.guidanceurl.value && form.formurl.value && form.year.value
  }

  render() {
    const {
      ctaText,
      completeText,
      submittingText,
      title,
      dispatch,
      modals,
      description,
    } = this.props
    const schema = this._schema()
    const form = this.props.forms[this.props.id]
    const disable = (form && form._isPosting)
    const forceClose = (form && form._hasCompleted)
    // const formHasFetched = this.props.hasFetched
    return (
      <Modal
        className={styles.bg}
        disable={disable}
        dispatch={dispatch}
        forceClose={forceClose}
        id="partnerPlanOverviewForm"
        modals={modals}
        onClose={this._hide}
      >
        <div className={styles.base}>
          <Heading className={styles.title} size="large">
            {title}
          </Heading>
          <p className={styles.content}>{description}</p>
          <Alert type="info">
            {`Partner plan ${this.props.partnerPlanAdmin.selectedPlanOverviewPage.year} overview form for ${this.props.partnerPlanAdmin.selectedPlanOverviewPage.planstage} `}
          </Alert>
          {form &&
          <form
            className={styles.form}
            id={this.props.id}
            noValidate="novalidate"
            onSubmit={this._handleSubmit}
          >
            <div className={styles.sectionHeader} />
            <fieldset>
              <ul>
                <TextInput
                  {...schema.ID}
                  handleChange={this._handleChange}
                  onBlur={this._handleValidation}
                  onFocus={this._handleFocus}
                  text={form.ID.value}
                />
                <TextInput
                  {...schema.planstage}
                  handleChange={this._handleChange}
                  onBlur={this._handleValidation}
                  onFocus={this._handleFocus}
                  text={form.planstage.value}
                />
                <TextInput
                  {...schema.status}
                  handleChange={this._handleChange}
                  onBlur={this._handleValidation}
                  onFocus={this._handleFocus}
                  text={form.status.value}
                />
                <li>
                  <TextInput
                    {...schema.year}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.year.value}
                  />
                </li>
                <li>
                  <TextInput
                    {...schema.formurl}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.formurl.value}
                  />
                </li>
                <li>
                  <TextInput
                    {...schema.guidanceurl}
                    handleChange={this._handleChange}
                    onBlur={this._handleValidation}
                    onFocus={this._handleFocus}
                    text={form.guidanceurl.value}
                  />
                </li>
              </ul>
            </fieldset>
            <br /><br />
            <div className={styles.footer}>
              <SubmitButton
                isLarge
                complete={this.props.forms[this.props.id]._isComplete}
                completeText={completeText} // Add validation rules
                disabled={!this.canSubmit()}
                submitting={this.props.forms[this.props.id]._isPosting}
                submittingText={submittingText}
              >
                {ctaText}
              </SubmitButton>
            </div>
          </form>
        }
        </div>
      </Modal>
    )
  }
}

export default PartnerPlanAdminOverviewDisplayForm



// WEBPACK FOOTER //
// ./src/views/PartnerPlans/PartnerPlanAdminOverviewDisplayForm.js